export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-r from-background-50 to-background-100 rounded-2xl border border-background-200/60 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
              如果您有影片推荐、内容合作或任何意见反馈，欢迎通过以下方式与我们取得联系。我们珍视每一位电影爱好者的声音。
            </p>
            <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-600">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                  <i className="ri-mail-line"></i>
                </span>
                contact@aiyaaiya.com
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                  <i className="ri-wechat-line"></i>
                </span>
                微信公众号：爱丫爱丫影院
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                  <i className="ri-timer-line"></i>
                </span>
                工作日 9:00-18:00
              </span>
            </div>
          </div>

          <div className="flex-shrink-0">
            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-send-plane-line"></i>
              </span>
              发送消息
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}